export default __webpack_public_path__ + "static/media/gokart.a118ca6c.jpg";